import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

interface Props {
  isTaskDetail?: boolean;
  isCalendarView?: boolean;
  isPadding?: boolean;
  isSelectedTask?: boolean;
  isCustomContextMenu?: boolean;
  isCreateTaskModal?: boolean;
  isAssignModal?: boolean;
  isMilestone?: boolean;
  isSubtask?: boolean;
  isActive?: boolean;
}

const SignMode = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  svg {
    vertical-align: middle;
  }

  .fill-color {
    stroke: var(--background-primary);
    fill: var(--border-secondary);
  }
  align-items: center;
  p {
    ${Typography.body_md_medium}
    margin: 0;
    color: var(--text-primary);
    white-space: nowrap;
  }

  ${mobile_xl(css`
    p {
      display: inline-flex;
    }
    .fill-color {
      display: none;
    }
  `)}
`;

const RightRow1 = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 5px 11px;
  align-items: center;
  border-radius: var(--border-radius-8);
  border: 0.5px solid transparent;
  :hover {
    background: var(--background-primary);
    border: 0.5px solid var(--border-primary);
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      border: 0.5px solid var(--border-primary);
      background: var(--background-primary);
    `}
`;

const RightText = styled.p`
  ${Typography.body_md}
  color: var(--text-primary);
  margin: 0;
  white-space: nowrap;
`;

const AvatarImage = styled.div`
  display: flex;
  align-items: center;
  border-radius: var(--border-radius-full);

  > div > img {
    max-width: 100%;
  }
`;
const AssignGroup = styled.div<Props>`
  padding: 3px 11px;
  border-radius: var(--border-radius-8);
  border: 0.5px solid transparent;

  :hover {
    background: var(--background-primary);
    border: 0.5px solid var(--border-primary);
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      border: 0.5px solid var(--border-primary);
      background: var(--background-primary);
    `}
  ul {
    display: flex;
    align-items: center;
    list-style-type: none;
    padding-left: 8px;
    margin: 0;
  }

  li {
    margin-left: -8px;
    border-radius: var(--border-radius-full);
    .plus-icon {
      visibility: hidden;
    }
  }
  .fill-color {
    stroke: var(--background-primary);
    path {
      stroke: var(--background-primary);
    }
  }
  .fill-color {
    fill: var(--text-tertiary);
  }
  .fill-color {
    svg {
    }
  }
  .plus-icon {
    fill: var(--border-secondary);
    stroke: var(--background-primary);
  }
`;
const HumanIcon = styled.div<Props>`
  padding: 5px 7px;
  border-radius: var(--border-radius-6);
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 6px;
  border: 0.5px solid var(--border-primary);
  p {
    ${Typography.body_md_medium}
    color: var(--text-secondary) !important;
    margin: 0;
  }

  svg {
    fill: var(--text-secondary);
  }
  :hover {
    background: var(--neutral-secondary);
    border-radius: var(--border-radius-6);
    p {
      color: var(--text-primary) !important;
    }
    svg {
      fill: var(--text-primary);
    }
  }
  ${mobile_xl(css`
    p {
      display: inline-flex;
    }
    padding: 5px;
  `)}
  ${(props: Props) =>
    props.isPadding &&
    css`
      cursor: pointer;
      padding: 5px 7px;
      :hover {
        p {
          color: var(--text-secondary) !important;
        }
      }
    `}
  ${(props: Props) =>
    props.isCreateTaskModal &&
    css`
      padding: 2px 7px;
      border-radius: var(--border-radius-6);
      ${mobile_xl(css`
        padding: 2px 7px !important;
      `)}
    `}
    ${(props: Props) =>
    props.isActive &&
    css`
      border: 0.5px solid var(--border-primary);
      background-color: var(--neutral-secondary);
    `}
`;

const AssignBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  svg {
    margin: 0;
  }
  .selected {
    background: var(--neutral-secondary);
    .checkbox-round {
      border: 1px solid var(--text-secondary);
    }
  }
  :last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;
const Assign = styled.div<Props>`
  padding: 6px 8px;
  border-radius: var(--border-radius-6);
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 6px;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  flex-wrap: wrap;

  :hover {
    background: var(--neutral-secondary);
    border-radius: var(--border-radius-6);
  }
  ${mobile_xl(css`
    padding: 5px;
    flex-wrap: wrap;
    max-width: max-content;
  `)}
  ${(props: Props) =>
    props.isCreateTaskModal &&
    css`
      padding: 2px 7px;
      border-radius: var(--border-radius-6);
      ${mobile_xl(css`
        padding: 2px 7px !important;
      `)}
    `}
  ${(props: Props) =>
    props.isActive &&
    css`
      border: 0.5px solid var(--border-primary);
      background-color: var(--neutral-secondary);
    `}
`;

const Div = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

const BlankDiv = styled.div`
  width: 14px;
  height: 14px;
`;

export { SignMode, RightRow1, AvatarImage, AssignGroup, RightText, HumanIcon, AssignBottom, Assign, Div, BlankDiv };
